module.exports = __webpack_public_path__ + "static/media/laos.0da72735.png";